<template>
  <div>
    <page-title title="About" />
    <hr />

    <content-block slug="about" />
  </div>
</template>

<script>
export default {
  name: 'About',
  props: {
  }
}
</script>